import { IMeetingPlaceSeoDescription } from '../../interfaces/meetingPlaceSeoDescription';
import { IMeetingPlacePageTenantEntertainmentItem } from './meetingPlacePageTenantEntertainmentItem';
import { IMeetingPlacePageTenantFoodBevItem } from './meetingPlacePageTenantFoodBevItem';
import { IMeetingPlacePageTenantShopItem } from './meetingPlacePageTenantShopItem';
import { gql } from '@apollo/client';

export type TTenantTypes =
  | IMeetingPlacePageTenantEntertainmentItem
  | IMeetingPlacePageTenantFoodBevItem
  | IMeetingPlacePageTenantShopItem;

export interface IMeetingPlacePageTenantList {
  slug: string;
  name: string;
  sys: {
    locale: string;
  };
  tenantsCollection: {
    items: TTenantTypes[];
  };
  customizedSlug: string;
  seoDescription: IMeetingPlaceSeoDescription;
}

export const MeetingPlacePageTenantsFragment = gql`
  fragment MeetingPlacePageTenants on MeetingPlacePageTenantList {
    name
    slug
    sys {
      locale
    }
    tenants {
      ... on Node {
        ... on MeetingPlacePageTenantShopItem {
          ...MeetingPlacePageTenantShopItem
        }
        ... on MeetingPlacePageTenantEntertainmentItem {
          ...MeetingPlacePageTenantEntertainmentItem
        }
        ... on MeetingPlacePageTenantFoodBevItem {
          ...MeetingPlacePageTenantFoodBevItem
        }
      }
    }
    seoDescription
  }
`;

export const MeetingPlacePageTenantListFragment = gql`
  fragment MeetingPlacePageTenantList on MeetingPlacePageTenantList {
    sys {
      id
      locale
    }
    name
    slug
    seoDescription
  }
`;
